import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "buttons-bar" }
const _hoisted_2 = { class: "network-connection-state" }
const _hoisted_3 = { class: "hint" }
const _hoisted_4 = { class: "hint__actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconNetworkStrength2Alert = _resolveComponent("IconNetworkStrength2Alert")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_NcPopover = _resolveComponent("NcPopover")
  const _component_LocalAudioControlButton = _resolveComponent("LocalAudioControlButton")
  const _component_LocalVideoControlButton = _resolveComponent("LocalVideoControlButton")
  const _component_NcIconSvgWrapper = _resolveComponent("NcIconSvgWrapper")
  const _component_IconMonitorOff = _resolveComponent("IconMonitorOff")
  const _component_IconMonitor = _resolveComponent("IconMonitor")
  const _component_NcActionButton = _resolveComponent("NcActionButton")
  const _component_NcActions = _resolveComponent("NcActions")
  const _component_IconMonitorShare = _resolveComponent("IconMonitorShare")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($options.qualityWarningTooltip)
        ? (_openBlock(), _createBlock(_component_NcPopover, {
            key: 0,
            boundary: $data.boundaryElement,
            "aria-label": $options.qualityWarningAriaLabel,
            trigger: "hover",
            "auto-hide": false,
            "no-focus-trap": "",
            shown: $options.showQualityWarningTooltip
          }, {
            trigger: _withCtx(() => [
              _createVNode(_component_NcButton, {
                id: "quality_warning_button",
                variant: "tertiary-no-background",
                class: "trigger",
                "aria-label": $options.qualityWarningAriaLabel,
                onClick: _cache[0] || (_cache[0] = $event => ($data.mouseover = !$data.mouseover))
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_IconNetworkStrength2Alert, {
                    "fill-color": "#e9322d",
                    size: 20
                  })
                ]),
                _: 1
              }, 8, ["aria-label"])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", null, _toDisplayString($options.qualityWarningTooltip.content), 1),
                _createElementVNode("div", _hoisted_4, [
                  ($options.qualityWarningTooltip.action)
                    ? (_openBlock(), _createBlock(_component_NcButton, {
                        key: 0,
                        variant: "primary",
                        class: "hint__button",
                        onClick: $options.executeQualityWarningTooltipAction
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($options.qualityWarningTooltip.actionLabel), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (!$data.isQualityWarningTooltipDismissed)
                    ? (_openBlock(), _createBlock(_component_NcButton, {
                        key: 1,
                        variant: "tertiary",
                        class: "hint__button",
                        onClick: $options.dismissQualityWarningTooltip
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($options.t('spreed', 'Dismiss')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 8, ["boundary", "aria-label", "shown"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_LocalAudioControlButton, {
      token: $props.token,
      conversation: $options.conversation,
      model: $props.model,
      "show-devices": !$props.isSidebar,
      variant: "tertiary"
    }, null, 8, ["token", "conversation", "model", "show-devices"]),
    _createVNode(_component_LocalVideoControlButton, {
      token: $props.token,
      conversation: $options.conversation,
      model: $props.model,
      "show-devices": !$props.isSidebar,
      variant: "tertiary"
    }, null, 8, ["token", "conversation", "model", "show-devices"]),
    _createVNode(_component_NcButton, {
      "aria-label": $options.t('spreed', 'Select virtual background'),
      title: $options.t('spreed', 'Select virtual background'),
      variant: "tertiary",
      onClick: _cache[1] || (_cache[1] = _withModifiers($event => ($options.emit('talk:media-settings:show', 'backgrounds')), ["stop"]))
    }, {
      icon: _withCtx(() => [
        _createVNode(_component_NcIconSvgWrapper, {
          svg: $setup.IconBackground,
          size: 20
        }, null, 8, ["svg"])
      ]),
      _: 1
    }, 8, ["aria-label", "title"]),
    (!$props.isSidebar && $options.isScreensharing)
      ? (_openBlock(), _createBlock(_component_NcActions, {
          key: 0,
          id: "screensharing-button",
          open: $data.screenSharingMenuOpen,
          "onUpdate:open": _cache[2] || (_cache[2] = $event => (($data.screenSharingMenuOpen) = $event)),
          title: $options.screenSharingButtonTitle,
          variant: "error",
          "aria-label": $options.screenSharingButtonAriaLabel,
          class: _normalizeClass([$options.screenSharingButtonClass, "app-navigation-entry-utils-menu-button"]),
          "boundaries-element": $data.boundaryElement,
          disabled: !$options.isScreensharingAllowed
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_IconMonitorOff, { size: 20 })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_NcActionButton, {
              "close-after-click": "",
              onClick: $options.showScreen
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_IconMonitor, { size: 20 })
              ]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Show your screen')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_NcActionButton, {
              "close-after-click": "",
              onClick: $options.stopScreen
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_IconMonitorOff, { size: 20 })
              ]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Stop screensharing')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["open", "title", "aria-label", "class", "boundaries-element", "disabled"]))
      : (!$props.isSidebar)
        ? (_openBlock(), _createBlock(_component_NcButton, {
            key: 1,
            title: $options.screenSharingButtonTitle,
            variant: "tertiary",
            "aria-label": $options.screenSharingButtonAriaLabel,
            disabled: !$options.isScreensharingAllowed,
            onClick: _withModifiers($options.toggleScreenSharingMenu, ["stop"])
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_IconMonitorShare, { size: 20 })
            ]),
            _: 1
          }, 8, ["title", "aria-label", "disabled", "onClick"]))
        : _createCommentVNode("", true)
  ]))
}